<h1 mat-dialog-title>Confirmación</h1>
<div mat-dialog-content class="dialog-content">
    <p>{{ data.question }}</p>
    <mat-slide-toggle
        *ngIf="data.showCloseScheduledBidsToggle"
        [(ngModel)]="closeScheduledBids"
        color="primary"
    >
        Finalizar programaciones de pujas asociadas
    </mat-slide-toggle>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="accent" (click)="onNoClick()" tabindex="2">No</button>
    <button mat-raised-button color="primary" (click)="onYesClick()" tabindex="1">Si</button>
</div>
